<form>
  <!-- Modal Header -->
  <div class="modal-header" [class]="checkType()">
    <h4 class="modal-title">Confirmation Dialog</h4>
    <!-- <button type="button" class="btn-close" data-dismiss="modal" tabindex=-1 (click)="closeDialog()"></button> -->
  </div>

  <div class="modal-body">
    <div class="container-fluid">
      <div class="p-3">
        <p class="messageText">{{ message }}</p>
        @for (item of injectContent; track item) {
            @if (item.injectType === INJECT_TYPE.COMPONENT) {
                <ng-container *ngComponentOutlet="item.content; inputs: item.data"/>
            } @else {
                <ng-container [ngTemplateOutlet]="$any(item.content)" [ngTemplateOutletContext]="{ $implicit: item.data }" />
            }
        }
      </div>

      @if (needExtraConfirm) {
        <div class="form-check">
          <input type="checkbox" class="form-check-input" id="cbAgreed" [(ngModel)]="agreed" [value]="agreed" name="agreed" />
          <label class="form-check-label checkBoxLabel text-danger" for="cbAgreed"> {{ extraConfirmMessage }}</label>
        </div>
      }
    </div>
  </div>

  <div class="modal-footer">
    @if (needExtraConfirm == false || agreed == true) {
      <button class="btn btn-outline-success" type="button" (click)="setConfirmation(true)" [disabled]="disableConfirm()">Yes</button>
    }
    <button class="btn btn-outline-danger" type="button" (click)="setConfirmation(false)">No</button>
  </div>
</form>
